import React, { useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';


export const AppModal = ({ showModal, onCloseModal, showInnerModalOnDecline = false, config }) => {

    const [modalTitle, setModalTitle] = useState(config.title);
    const [modalText, setModalText] = useState(config.message);
    const [showBackButton, setBackButtonState] = useState(false);

    const onDeclineClick = () => {
        if (showInnerModalOnDecline) {
            setModalTitle(config.declinedTitle);
            setModalText(config.declinedMessage);
            setBackButtonState(true);
        } else {
            onCloseModal(false);
        }
    };

    const setInitialState = () => {
        setModalTitle(config.title);
        setModalText(config.message);
        setBackButtonState(false);
    };

    const mapAlignment = (alignValue) => {
        switch (alignValue) {
            case 'right':
                return 'flex-end';
            case 'center':
                return 'center';
            default:
                return 'flex-start'
        }
    };

    const buttonStyles = (type) => {
        let color = '';
        let backgroundColor = '';

        if (type === 'confirm') {
            color = config.confirmTextColour || '#ffffff'
            backgroundColor = config.confirmColour || '#00b100'
        }

        if (type === 'decline') {
            color = config.declinedTextColour || '#ffffff'
            backgroundColor = config.declinedColour || '#e80404'
        }

        return { color, backgroundColor, borderColor: backgroundColor }
    };

    useEffect(() => {
        setInitialState();
    }, [showModal])

    return (
        <Modal
            show={showModal}
            backdrop="static"
            centered
            keyboard={false}
        >
            <Modal.Header>
                {
                    config.logo &&
                    <img
                        style={{ alignSelf: mapAlignment(config.logoAlign) }}
                        className="modal-logo"
                        src={config.logo}
                        alt="logo"
                    />
                }
                <Modal.Title>{ modalTitle }</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <div className="modal-text">{ modalText }</div>
            </Modal.Body>

            <Modal.Footer>
                {
                    showBackButton ?
                    <Button className="modal-decline-btn" onClick={setInitialState}>BACK</Button> :
                    <div style={{
                        margin: 0,
                        width: "100%",
                        display: "flex",
                        justifyContent: mapAlignment(config.buttonsAlign)
                    }}>
                        <Button
                            style={buttonStyles('confirm')}
                            className="modal-accept-btn"
                            onClick={() => onCloseModal(true)}
                        >CONFIRM</Button>
                        <Button
                            style={buttonStyles('decline')}
                            className="modal-decline-btn"
                            onClick={onDeclineClick}
                        >DECLINE</Button>
                    </div>
                }


            </Modal.Footer>
        </Modal>
    )
}
